/**
 * The GoodSender mark: an envelope-check plate on the rounded square, drawn
 * inline so it inherits nothing and ships no asset request. Decorative next
 * to the wordmark text, so it is always `aria-hidden`.
 */
export function LogoMark({ size = 30 }: { size?: number }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden>
      <rect width="100" height="100" rx="22.37" fill="var(--gs-accent)" />
      <rect x="14" y="22" width="72" height="56" rx="8" stroke="var(--gs-on-accent)" strokeWidth="6" fill="none" />
      <path d="M22 42 L40 60 L82 28" stroke="var(--gs-on-accent)" strokeWidth="6" strokeLinejoin="round" strokeLinecap="round" fill="none" />
    </svg>
  );
}
